import { render, staticRenderFns } from "./Tableros.vue?vue&type=template&id=b5168596"
import script from "./Tableros.vue?vue&type=script&lang=js"
export * from "./Tableros.vue?vue&type=script&lang=js"
import style0 from "./tableros.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./tablerosFront.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./tablerosExtra.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports